export const ADD_UPLOADED_CLAIMS = "ADD_UPLOADED_CLAIMS";

export function addUploadedClaims(claims) {
  return {
    type: ADD_UPLOADED_CLAIMS,
    payload: claims
  };
}

export const ADD_VIEW_CLAIMS = "ADD_VIEW_CLAIMS";

export function addViewClaims(claims) {
  return {
    type: ADD_VIEW_CLAIMS,
    payload: claims
  };
}

export const SET_UPLOAD_CHECK = "SET_UPLOAD_CHECK";

export function setUploadCheck(bool) {
  return {
    type: SET_UPLOAD_CHECK,
    payload: bool
  };
}


export const IS_RECENT_BATCH = "IS_RECENT_BATCH";

export function isRecentBatch(bool) {
  return {
    type: IS_RECENT_BATCH,
    payload: bool
  };
}

export const READY_ALL_CLICK = "READY_ALL_CLICK";
export function readyAllClick(val) {
  return {
    type: READY_ALL_CLICK,
    payload: val
  };
}




// WEBPACK FOOTER //
// ./src/app/submit_claims/upload/actions.js